import React, { useState } from "react";
import { GoogleMap, useJsApiLoader, Marker } from "@react-google-maps/api";
import { IonIcon, IonImg, isPlatform } from "@ionic/react";
import { convertLatLongIntoAddress } from "../components/Portal/addNewAddress";
import { location } from "ionicons/icons";
import { checkMediaQuery } from ".";

declare let window: any;

const library: Array<any> = ["places"];
export const GoogleApiKey = isPlatform("android")
	? "AIzaSyAg0mIiyGldcj3V0H5a5F01LdyWjZN2a8g" // "AIzaSyDeeAP8YYOQnaFs3AOUmJlFGHVOTKD52go"
	: isPlatform("ios")
	? "AIzaSyAueZCHoLxsa7YzNm2hLP3UHYhsSZg9Css"
	: "AIzaSyAJiQDsW8req1tKBNcjMeB3clQmge3wHCg";

function Maps(props: any) {
	const { isLoaded } = useJsApiLoader({
		id: "google-map-script",
		googleMapsApiKey: GoogleApiKey,
		libraries: library,
	});

	const [map, setMap] = React.useState(null);
	const [mapRef, setMapRef] = useState(null);
	const [mapCenter, setCenter] = useState({ lat: null, lng: null });
	const onMarketDragged = (event: any) => {
		const { latLng } = event;
		const { lat, lng } = latLng;
		const latitude = lat();
		const longitude = lng();
		props.storeCurrentLatLong(latitude, longitude);
		convertLatLongIntoAddress(latitude, longitude, props);
	};

	const onLoad = React.useCallback(function callback(map) {
		const bounds = new window.google.maps.LatLngBounds();
		// map.fitBounds(bounds);
		setMap(map);
	}, []);

	const onUnmount = React.useCallback(function callback(map) {
		setMap(null);
	}, []);
	const centerLatLongAddress = (ref: any) => {
		props.storeCurrentLatLong(ref.center.lat(), ref.center.lng());
		convertLatLongIntoAddress(ref.center.lat(), ref.center.lng(), props);
	};
	const center = {
		lat: props.lat,
		lng: props.long,
	};
	return isLoaded ? (
		<div>
			<GoogleMap
				// mapContainerStyle={containerStyle}
				mapContainerClassName={"google-map-style"}
				center={center}
				zoom={18}
				onLoad={(e: any) => {
					onLoad(e);
					setMapRef(e);
					// setCenter(e.getCenter().toJSON());
				}}
				onCenterChanged={() => {
					if (!!mapRef) {
						centerLatLongAddress(mapRef);
					}
				}}
				onUnmount={onUnmount}
				options={{
					fullscreenControl: false,
					zoomControl: false,
					streetViewControl: false,
					mapTypeControl: false,
				}}
			>
				{/* <Marker
          onDragEnd={(event) => onMarketDragged(event)}
          position={center}
          options={{
            crossOnDrag: false,
            draggable: true,
          }}
        ></Marker> */}
				<div className="float_marker">
					<img src={"/images/pointer.svg"} />
					{/* <IonIcon icon={location} className="notifications_icon" /> */}
				</div>
				<img src="/images/Bitmap.png" className="google-icon" />
			</GoogleMap>
		</div>
	) : (
		<></>
	);
}

export default React.memo(Maps);
